<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="/">메인 사이트로</a>
      <router-link to="/">메인</router-link>
      <router-link to="/WageCalendar">달력형 계산기</router-link>
      <a v-if="this.$store.state.loginState == '0'"><router-link to="/LoginView">로그인</router-link></a>
      <a v-if="this.$store.state.loginState == '1'">로그아웃</a>
    </div>
  </nav>
</template>

<script>
import { getCurrentInstance } from '@vue/runtime-core';
export default {
  data() {
    return {
      app:"",
    }
  },
  created() {
    this.app = getCurrentInstance();
    this.connect();
  },
  methods: {
    connect() {
      this.socket = new WebSocket(this.app.appContext.config.globalProperties.$wsServerUri + "webSocket/VueWageLiveTime");
      this.socket.onopen = () => {
        console.log("실시간 서버 연결 완료");
        // 응답 코드
        this.socket.onmessage = ({data}) => {
          let json = JSON.parse(data);

          // 시계
          if(json.event == "liveTime") {
            this.$store.state.liveConnectCount = json.count;
            this.$store.state.liveTime = json.time;
          }
          // log
          else if(json.event == "log") {
            console.log("서버 메세지 받음 : " + json.content);
          }
          // alert log
          else if(json.event == "alertLog") {
            console.log("서버 알림 메세지 받음 : " + json.content);
            alert(json.content);
          }
          // version check
          else if(json.event == "versionCheck") {
            console.log("버전 정보 요청 : " + this.app.appContext.config.globalProperties.$version);
            this.socket.send('{event:"versionControll", version:' + this.app.appContext.config.globalProperties.$version + '}');
          }
          // save local storage
          else if(json.event == "saveLocalStorage") {
            console.log("local storage 저장 요청 받음 : " + json.key + " , " + json.values);
            window.localStorage.setItem(json.key, json.values);
          }
          // return local storage
          else if(json.event == "returnLocalStorage") {
            console.log("local storage 반환 요청 받음 : " + json.name);
            this.socket.send('{event:"returnLocalStorage", name:' + json.name + ', values:' + localStorage.getItem(json.key) + '}');
          }
          // login state change
          else if(json.event == "loginStateChange") {
            console.log("로그인 상태 변화됨 현 : " + this.$store.state.loginState + ", 후 : " + json.values);
            if(json.values == "true") {
              this.$store.state.loginState = "1"
            } else {
              this.$store.state.loginState = "0"
            }
            // 페이지 이동
            this.$router.push({ path: '/' })
          }
        };
      };
      this.socket.onclose = () => {
        console.log("liveTime 연결 해재됨");
        alert("실시간 웹서버 연결이 종료 되었습니다.");
      };
      this.app.appContext.config.globalProperties.$socket = this.socket;
    },
  },
}
</script>

<style>

</style>